import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { FhSideBarHeaderConfigModel } from '../../helpers/objects/fh-side-bar-header-config/fh-side-bar-header-config-model';
import { FhSideBarProviderService } from '../../helpers/providers/fh-side-bar-provider.service';
import { FhSideBarVisibleEmitterModel } from '../../helpers/objects/fh-side-bar-visible-emitter/fh-side-bar-visible-emitter-model';

@Component({
  selector: 'ui-fh-side-bar-header',
  templateUrl: './fh-side-bar-header.component.html',
  styleUrl: './fh-side-bar-header.component.scss'
})
export class FhSideBarHeaderComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input() id: string = '';
  config: FhSideBarHeaderConfigModel = new FhSideBarHeaderConfigModel();
  configHeaderSubscription: Subscription = new Subscription();

  constructor(private fhSideBarProviderService: FhSideBarProviderService, private router: Router, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.backgroundEvents();
  }
  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    this.configHeaderSubscription.unsubscribe();
  }

  backgroundEvents() {
    this.configHeaderSubscription = this.fhSideBarProviderService.configHeaderEmitter.subscribe({
      next: (response: FhSideBarHeaderConfigModel) => (this.config = response)
    });
  }

  setRouteAndOutlet(clear: boolean) {
    let json: any;

    json = [{ outlets: {} }];
    if (clear) {
      json[0].outlets[this.config.outlet!] = null;
    } else {
      if (this.config.return) {
        // return to previous pages removing elements from the URL in case we have :ids
        return this.getReturnRoute();
      } else {
        // use parentNavigation provided in route
        json[0].outlets[this.config.outlet!] = this.config.parentNavigation ? this.config.parentNavigation.split('/') : this.config.parentNavigation;
      }
    }
    return json;
  }

  onClickNavigateBack() {
    if (!this.config.navigateBackButton) {
      return;
    }

    if (!this.config.outlet) {
      this.fhSideBarProviderService.navigateBackHeaderEmitter.emit(true);
    } else {
      this.router.navigate(this.setRouteAndOutlet(false));
    }
  }

  onClickCloseButton() {
    this.fhSideBarProviderService.visibleChangedEmitter.emit(new FhSideBarVisibleEmitterModel({ id: this.id }));
    this.router.navigate(this.setRouteAndOutlet(true));
  }

  getReturnRoute() {
    const url = this.router.url;
    const outletPrefix = this.config.outlet! + ':';
    const outletStartIndex = url.indexOf(outletPrefix);
    if (outletStartIndex === -1) {
      console.error('No outlet found in the URL.');
      return [];
    }
    // Extract and process the path for the outlet
    const outletPath = url.substring(outletStartIndex + outletPrefix.length);
    const segments = outletPath.split('/');

    const segmentsToRemove = this.config.segmentsToRemove || 1; // removes last element by default
    if (segments.length > segmentsToRemove) {
      segments.splice(-segmentsToRemove);
    }
    // Create the new path for the outlet after removing elements
    const newPath = segments.join('/');
    return [{ outlets: { [this.config.outlet!]: newPath } }];
  }

  protected readonly alert = alert;
}
